module.exports = __webpack_public_path__ + "pic1.jpg?a7f172b4e7f3484822ce91ee34c58036";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testimonials/pic1.jpg
// module id = 52
// module chunks = 13